import { render } from "./NTFToolkit.vue?vue&type=template&id=8481ed2a&scoped=true&bindings={\"ntfToolkitData\":\"data\",\"isLoading\":\"data\",\"headers\":\"data\",\"bowlItems\":\"data\",\"breadItems\":\"data\",\"breakfastItems\":\"data\",\"pizzaItems\":\"data\",\"pouchItems\":\"data\",\"sandwichItems\":\"data\",\"trayItems\":\"data\",\"getNTFToolkitData\":\"options\",\"generateSectionLists\":\"options\",\"processItems\":\"options\"}"
import script from "./NTFToolkit.vue?vue&type=script&lang=js"
export * from "./NTFToolkit.vue?vue&type=script&lang=js"

import "./NTFToolkit.vue?vue&type=style&index=0&id=8481ed2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8481ed2a"

export default script